import { render, staticRenderFns } from "./VenueGoverningLawOutput.vue?vue&type=template&id=dde05266&"
import script from "./VenueGoverningLawOutput.vue?vue&type=script&lang=js&"
export * from "./VenueGoverningLawOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/VenueGoverningLawOutput.vue
// module id = null
// module chunks = 